"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LabelTextInline = _interopRequireDefault(require("../Shared/LabelTextInline"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ServiceAreas = function ServiceAreas(_ref) {
  var className = _ref.className,
    service_areas = _ref.service_areas,
    intlProvider = _ref.intlProvider;
  var nationalServiceArea = service_areas.find(function (sA) {
    return sA.service_area_type === 'national';
  });
  var statesServiceAreas = service_areas.filter(function (sA) {
    return sA.service_area_type === 'state';
  }).map(function (sA) {
    return sA.name;
  });
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, {
    defaultLocale: "en",
    locale: intlProvider.locale,
    messages: intlProvider.messages
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "mb-one"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "J6BEWS",
    description: "service-areas",
    defaultMessage: "Service Areas"
  })), nationalServiceArea && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_LabelTextInline["default"], {
    className: "mb-one",
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "SqRb6P",
      description: "national",
      defaultMessage: "National"
    }),
    content: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "VTO8h4",
      description: "content-text",
      defaultMessage: "This program serves the entire country"
    })
  })), !nationalServiceArea && /*#__PURE__*/_react["default"].createElement("div", null, statesServiceAreas.length > 0 && /*#__PURE__*/_react["default"].createElement(_LabelTextInline["default"], {
    className: "mb-one",
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "XW82Wp",
      description: "states",
      defaultMessage: "States"
    }),
    content: statesServiceAreas
  })))));
};
ServiceAreas.propTypes = {
  className: _propTypes["default"].string,
  /** Array of Service Areas objects. It can contain National Service area if the program serves the entire country, States or Cities */
  service_areas: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    name: _propTypes["default"].string,
    program: _propTypes["default"].shape({
      id: _propTypes["default"].string
    }),
    service_area_type: _propTypes["default"].string,
    state_abbreviation: _propTypes["default"].string
  })),
  intlProvider: _propTypes["default"].shape({
    locale: _propTypes["default"].string,
    messages: _propTypes["default"].array
  })
};
ServiceAreas.defaultProps = {
  className: '',
  service_areas: [],
  intlProvider: {
    locale: 'en',
    messages: []
  }
};
var _default = exports["default"] = ServiceAreas;